/**
 * Tag filters — Flatpickr date pickers + form submission.
 * Native <select> styled via CSS (matches KMU Choices.js look).
 * Migrated from tag-filters.js (156 lines).
 */

import flatpickr from "flatpickr";
import type { Instance as FlatpickrInstance } from "flatpickr/dist/types/instance";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";

interface FlatpickrInput extends HTMLInputElement {
  _flatpickr?: FlatpickrInstance;
}

export function initTagFilters(): void {
  // Flatpickr date pickers
  flatpickr("#from", { locale: Ukrainian, dateFormat: "d/m/Y", allowInput: true });
  flatpickr("#till", { locale: Ukrainian, dateFormat: "d/m/Y", allowInput: true });

  // Date picker icon clicks
  document
    .querySelectorAll<HTMLElement>(".accessible-datepicker-icon")
    .forEach((icon) => {
      icon.addEventListener("click", (e: Event) => {
        e.preventDefault();
        const input = icon.parentElement?.querySelector<FlatpickrInput>(
          ".accessible-datepicker-input",
        );
        input?._flatpickr?.open();
      });
    });

  // Form submission
  const form = document.getElementById("timelineForm");
  form?.addEventListener("submit", (e: Event) => {
    e.preventDefault();

    const typeEl = document.getElementById("type") as HTMLSelectElement | null;
    const fromEl = document.getElementById("from") as HTMLInputElement | null;
    const tillEl = document.getElementById("till") as HTMLInputElement | null;

    const queryParams: string[] = [];

    if (typeEl?.value) {
      queryParams.push("post_type=" + encodeURIComponent(typeEl.value));
    }

    if (fromEl?.value) {
      const parts = fromEl.value.split("/");
      if (parts.length === 3) {
        queryParams.push("date_from=" + parts[2] + "-" + parts[1] + "-" + parts[0]);
      }
    }

    if (tillEl?.value) {
      const parts = tillEl.value.split("/");
      if (parts.length === 3) {
        queryParams.push("date_to=" + parts[2] + "-" + parts[1] + "-" + parts[0]);
      }
    }

    let newUrl = window.location.pathname;
    if (queryParams.length > 0) {
      newUrl += "?" + queryParams.join("&");
    }
    window.location.href = newUrl;
  });

  // Skip links
  document.getElementById("skipTimelineFilters")?.addEventListener("click", (e: Event) => {
    e.preventDefault();
    document.getElementById("timelineResult")?.focus();
  });

  document.getElementById("backToTimelineFilters")?.addEventListener("click", (e: Event) => {
    e.preventDefault();
    document.getElementById("skipTimelineFilters")?.focus();
  });
}

// Imported and called explicitly by news-index.ts and event-index.ts
